import React from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import { App, ProtectedRoute } from "./App";
import SignIn from './nps-components/SignIn';
import ForgetPassword from "./nps-components/password/ForgetPassword";
import SetPassword from "./nps-components/password/SetPassword";
import Success from "./nps-components/password/Success";
import { AuthProvider, useAuth } from "./contexts/AuthContext";
import { LoaderProvider } from "./contexts/LoaderContext";
import { NotificationProvider } from "./contexts/NotificationContext";
import "./index.css";

const Root = () => {

  return (
    <LoaderProvider>
      <AuthProvider>
        <NotificationProvider>
          <BrowserRouter basename="/nps-task/app">
            <Routes>
              {/* Public Routes */}
              <Route path="/" element={<SignIn />} />
              <Route path="SignIn" element={<SignIn />} />
              <Route path="ForgetPassword" element={<ForgetPassword />} />
              <Route path="SetPassword" element={<SetPassword />} />
              <Route path="Success" element={<Success />} />

              {/* Protected Routes */}
              <Route element={<ProtectedRoute />}>
                <Route path="/*" element={<App />}>
                  {/* <Route path="home" element={<TaskBoard />} />                  
                  <Route path="notifications" element={<WebNotificationList userId={user?.id} />} />
                  <Route path="notifications/:id" element={<WebNotificationDetail userId={user?.id} />} /> */}
                </Route>
              </Route>
            </Routes>
          </BrowserRouter>
        </NotificationProvider>
      </AuthProvider>
    </LoaderProvider>
  );
};

const root = createRoot(document.getElementById("root"));
root.render(<Root />);

